import HoursOfOperationDay from './HoursOfOperationDay';

export {
  HoursOfOperationDay, // eslint-disable-line
};



// WEBPACK FOOTER //
// ./public/js/components/HoursOfOperation/components/index.js